import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { take } from 'rxjs/operators';
import { UserFromLoginDto } from 'src/app/core/models/dto/user-from-login-dto';

@Directive({
  selector: '[appDisableIfNoRole]',
  standalone: false,
})
export class DisableIfNoRoleDirective implements OnInit {
  // Agora aceita string única ou array de strings
  @Input('appDisableIfNoRole') requiredRoles: string[] | string = [];
  user: UserFromLoginDto | null = null;

  private masterRoles = ['Admin'];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private authService: AuthService,
  ) {
    this.authService.currentUser$.pipe(take(1)).subscribe({
      next: (user) => {
        if (user) this.user = user;
      },
    });
  }

  ngOnInit(): void {
    const userRoles = this.user?.roleName || [];

    // 1. Verifica se é Admin Global (Libera tudo)
    const isGlobalMaster = userRoles.some((r) => this.masterRoles.includes(r));
    if (isGlobalMaster) {
      return;
    }

    // Normaliza input para array
    const rolesToCheck = Array.isArray(this.requiredRoles)
      ? this.requiredRoles
      : [this.requiredRoles];

    const hasSpecificRole = userRoles.some((r) => rolesToCheck.includes(r));

    if (!hasSpecificRole) {
      this.renderer.addClass(this.el.nativeElement, 'opacity-40');
      this.renderer.addClass(this.el.nativeElement, 'pointer-events-none');
      this.renderer.addClass(this.el.nativeElement, 'grayscale');
      this.renderer.addClass(this.el.nativeElement, 'cursor-not-allowed');
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
    }
  }
}
